<template>
  <div class="default-table">
    <div style="width: 95%;margin: 0 auto;">
      <div class="default-table form-card"
           style="width: 100%;margin: unset;"
           v-loading="loading"
           element-loading-text="加载中……"
           element-loading-spinner="el-icon-loading">
        <el-table :data="table">
          <el-table-column label="核算归属月份" width="120" align="center">
            <template v-slot="{row:{date_check}}">
              <b v-if="date_check==='累计'">累计</b>
              <span v-else>{{ date_check|parseTime('{y}年{m}月') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="红人" width="120" header-align="center" align="center">
            <template v-slot="{row:{artist_name}}">
              {{ artist_name ? artist_name : '-'}}
            </template>
          </el-table-column>
          <el-table-column label="平台" prop="platform" width="120" header-align="center" align="center" />
          <el-table-column label="直播GMV" prop="settlement_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{settlement_amount}}">
              ￥{{ settlement_amount|numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="保量金额" prop="gq_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{gq_amount}}">
              ￥{{ gq_amount|numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="不含税收入" prop="un_tax_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{un_tax_amount}}">
              ￥{{ un_tax_amount|numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="应发金额" prop="deserve_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{deserve_amount}}">
              ￥{{ deserve_amount|numberFormat(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {liveGuaranteeTheOrderRecordManually} from "@/api/liveGuarantee";

export default {
  name: 'LiveDataManually',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      table: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList: async function () {
      this.loading = true
      const {model: {data: {list}}} = await liveGuaranteeTheOrderRecordManually({order_id: this.orderId})
      this.loading = false
      this.table = list
    }
  }
}
</script>
<style scoped>

</style>
